module.exports = __webpack_public_path__ + "static/media/transactionRecentScrollButton.86732445.svg";